import React, { Fragment, useState } from "react";
import Services from "../../api/service";
import { useParams } from "react-router-dom";
import ModalVideo from "react-modal-video";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/It-Services-Components/Footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/ser-01.svg";
import srImg from "../../images/shape/brd_shape.png";
// import srImg2 from "../../images/service/Salesnest_Logo_PNG.png";
// import srImg2 from "../../images/hero/cd-img.png";
import vImg from "../../images/video/img03.jpg";
import vImg2 from "../../images/video/polygon02.png";
import sImg1 from "../../images/icon/sd-icon01.svg";
import sImg2 from "../../images/icon/sd-icon02.svg";
import sImg3 from "../../images/icon/sd-icon03.svg";
import sImg4 from "../../images/icon/sd-icon04.svg";
import shape from "../../images/shape/sd-shape.png";
import sicon from "../../images/icon/check-icon.svg";
import Header2 from "../../components/Header2/Header2";

const ServiceSinglePage = (props) => {
  const { slug } = useParams();

  const ServiceDetails = Services.find((item) => item.slug === slug);

  const [isOpen, setOpen] = useState(false);

  console.log("logoService path:", ServiceDetails.logoService);

  return (
    <Fragment>
      <div className="sco_agency">
        <Header2 />
        <main className="page_content service-single-page">
          <section
            className="page-title  pt-200 pos-rel bg_img"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            <div className="container">
              <div className="page-title-wrap sd-title-wrap">
                <div className="row mt-none-30 align-items-end">
                  <div className="col-lg-9 mt-30">
                    <div className="page-title-box">
                      <span className="sub-title d-flex align-items-start justify-content-start flex-column gap-2 flex-wrap">
                        <span className="d-flex align-items-center gap-2">
                          <img src={icon} alt="" />
                          {ServiceDetails.title}
                        </span>

                        {ServiceDetails.officialSite && (
                          <a
                            href={`https://${ServiceDetails.officialSite}`}
                            className="custom-visit-btn mt-4"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            🌐 Visit Official Site
                          </a>
                        )}
                      </span>

                      <h2 className="title">
                        {ServiceDetails.shortDescription}
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-3 mt-30">
                    <div className="sd-right-img pos-rel">
                      <img src={ServiceDetails.logoService} alt="logoService" />
                      <div className="sd-arrow-shape">
                        <img className="xbzoominzoomup" src={srImg} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="video pt-70 pb-65">
            <div className="container">
              <div className="xb-video sd-video pos-rel">
                <img src={vImg} alt="" />
                <button
                  className="popup-video btn-video"
                  onClick={() => setOpen(true)}
                >
                  <img src={vImg2} alt="" />
                </button>
              </div>
            </div>
          </div>
          <div className="sd-ser-content_wrap pb-110">
            <div className="container">
              <div className="sd-ser-content">
                <h2 className="sd-title">
                  What Thinking {ServiceDetails.title}
                </h2>
                <p className="sd-content">{ServiceDetails.info}</p>
              </div>
            </div>
          </div>
          <div className="sd-process_warp">
            <div className="container">
              <div className="sd-heading">
                <h2 className="sd-title">Service Process</h2>
                <p className="sd-content">
                  {ServiceDetails?.title ??
                    "Our service process begins with..."}
                </p>
              </div>

              <div className="sd-process_inner ul_li">
                {ServiceDetails?.serviceProcess?.map((item, index) => (
                  <div className="sd-process-item" key={index}>
                    <div className="xb-item--icon">
                      <img src={item.icon} alt={item.title} />
                    </div>
                    <h3 className="xb-item--title">{item.title}</h3>
                    <p className="xb-item--contact">{item.desc}</p>
                    <span className="xb-item--number">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>
                ))}
                <div className="sd-shape">
                  <img src={shape} alt="decorative shape" />
                </div>
              </div>
            </div>
          </div>

          <div className="sd-service_wrap pt-115 pb-130">
            <div className="container">
              <div className="sd-ser-outcome">
                <div className="sd-heading">
                  <h2 className="sd-title">Services outcome</h2>
                  <div className="sd-content">
                    {ServiceDetails.serviceOutcome?.map((point, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-start gap-2 mb-2"
                      >
                        <img
                          src={sicon}
                          alt="icon"
                          style={{ width: "18px", marginTop: "5px" }}
                        />
                        <span>{point}</span>
                      </div>
                    ))}
                  </div>
                </div>
                {/* <div className="sd-list-item ul_li">
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Enhance Credibility and Trust.
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Improve Search Engine Rankings.
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Foster Strategic Partnerships.
                    </li>
                  </ul>
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Showcase Thought Leadership.
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Drive Targeted Traffic.
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Support Long-Term Growth.
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </main>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="7e90gBu4pas"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};
export default ServiceSinglePage;
